import { Col } from "react-grid-system";
import styles from "./DataPanelContent.module.css";
import DetailsRow from "../../DetailsRow";
import { BothDataPanel } from "../../../lib/api/models";
import { convertDateStringToMonthDayYearFormat } from "../../../lib/formatting";
import Tooltip from "../../common/Tooltip";

const strings = {
  cycleCode: "Cycle Cd",
  pricingTierTitle: "Pricing Tier Desc",
  pricingControlCure: "Pricing/Control/Cure",
  lateFeeTitle: "Late Fee Desc",

  currentMinPayDueDescription: "Curr MPD Desc",
  lastStatementMPDDescription: "Last Stmt MPD Desc",
  lastMPDChangeDate: "Last MPD Chng Dt",

  lastStatementPricing: "Last Stmt Pricing",
  lastStatementPricingDescription: "Last Stmt Pricing Tier Desc",
  dailyPayoffRate: "Daily PayOff Rt",

  statusCodeChangeDate: "Status Cd Chng Dt",
  renewalPeriod: "Renewal Period",
};

const TOOLTIP_SHORT_THRESHOLD_CHARS = 15;

export default function BothInnerContent(data: BothDataPanel) {
  return (
    <>
      <Col xs={3}>
        <DetailsRow
          className={styles.detailsRow}
          label={strings.cycleCode}
          value={data.cycleCode}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.pricingTierTitle}
          value={data.pricingTierTitle}
          tooltip={
            data.pricingTierDescription || data.pricingStrategySeverityLevel ? (
              <Tooltip>
                <div className={styles.pricingTierTooltipContent}>
                  {data.pricingTierDescription && (
                    <div>{data.pricingTierDescription}</div>
                  )}
                  {data.pricingStrategySeverityLevel && (
                    <div>{data.pricingStrategySeverityLevel}</div>
                  )}
                </div>
              </Tooltip>
            ) : null
          }
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.pricingControlCure}
          value={data.pricingControlCure}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.lateFeeTitle}
          value={data.lateFeeTitle}
          tooltip={
            <Tooltip
              variant={
                data.lateFeeDescription.length <= TOOLTIP_SHORT_THRESHOLD_CHARS
                  ? "short"
                  : "long"
              }
            >
              {data.lateFeeDescription}
            </Tooltip>
          }
        />
      </Col>
      <Col xs={3}>
        <DetailsRow
          className={styles.detailsRow}
          label={strings.currentMinPayDueDescription}
          value={data.currentMinPayDueDescription}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.lastStatementMPDDescription}
          value={data.lastStatementMPDDescription}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.lastMPDChangeDate}
          value={convertDateStringToMonthDayYearFormat(data.lastMPDChangeDate)}
        />
      </Col>
      <Col xs={3}>
        <DetailsRow
          className={styles.detailsRow}
          label={strings.lastStatementPricing}
          value={data.lastStatementPricing}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.lastStatementPricingDescription}
          value={data.lastStatementPricingDescription}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.dailyPayoffRate}
          value={data.dailyPayoffRate.toString()}
        />
      </Col>
      <Col xs={2}>
        <DetailsRow
          className={styles.detailsRow}
          label={strings.statusCodeChangeDate}
          value={convertDateStringToMonthDayYearFormat(
            data.statusCodeChangeDate,
          )}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.renewalPeriod}
          value={data.renewalPeriod}
        />
      </Col>
    </>
  );
}
